var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 37,
    fill: "#00C4B9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4153 47.2995C32.5384 47.2995 31.7059 47.0886 30.9733 46.6668C29.2417 45.6678 28.2871 43.6365 28.2871 40.9614V33.0471C28.2871 30.3609 29.2417 28.3407 30.9733 27.3417C32.7049 26.3427 34.936 26.5314 37.267 27.8745L44.1157 31.8261C46.4356 33.1692 47.7232 35.0118 47.7232 37.0098C47.7232 39.0078 46.4467 40.8504 44.1157 42.1935L37.267 46.1451C35.9239 46.911 34.6141 47.2995 33.4153 47.2995ZM33.4153 28.3629C32.8159 28.3629 32.2831 28.4961 31.8058 28.7736C30.607 29.4618 29.9521 30.9825 29.9521 33.0471V40.9503C29.9521 43.0149 30.607 44.5245 31.8058 45.2238C33.0046 45.9231 34.6474 45.7233 36.4345 44.691L43.2832 40.7394C45.0703 39.7071 46.0582 38.3862 46.0582 36.9987C46.0582 35.6112 45.0703 34.2903 43.2832 33.258L36.4345 29.3064C35.3467 28.6848 34.3255 28.3629 33.4153 28.3629Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/PlayIcon.f9160270267d24afe4fd98999ca89332.svg";
export { ForwardRef as ReactComponent };